import { Button, Group, Icon, Text } from '@inflearn/ds-react-next';
import { faChevronRight } from '@inflearn/pro-regular-svg-icons';

interface Props {
  dateLabel: string;
  date: string;
  href: string;
}

export function GiftItemHeader({ dateLabel, date, href }: Props) {
  return (
    <Group justify="space-between" align="center">
      <Group gap={4}>
        <Text size="sm" fw={500} c="dark.6">
          {dateLabel}
        </Text>
        <Text size="sm" fw={700} c="gray.9">
          {date}
        </Text>
      </Group>
      <Button
        component="a"
        href={href}
        variant="subtle"
        color="dark"
        size="xs"
        radius="md"
        styles={{
          root: {
            '&&': {
              paddingLeft: 7,
              paddingRight: 7,
            },
          },
        }}
        rightSection={<Icon icon={faChevronRight} size="xs" />}
      >
        자세히 보기
      </Button>
    </Group>
  );
}
